import PrintHandler from './PrintHandler';

export default PrintHandler;
